import { FunctionComponent } from 'react';
import { BarChart as MuiBarChart } from '@mui/x-charts/BarChart';

// Una sola serie: barras en cian oscuro de marca (contraste >= 3:1 sobre blanco), ejes y grilla
// recesivos en los grises de la marca y etiquetas en el color de texto (no en el de la serie).
const CHART_SX = {
  '& .MuiChartsAxis-tickLabel': {
    fill: 'var(--vdr-mute)',
    fontFamily: 'var(--vdr-font-body)'
  },
  '& .MuiChartsAxis-line, & .MuiChartsAxis-tick': {
    stroke: 'var(--vdr-line-strong)'
  },
  '& .MuiChartsGrid-line': {
    stroke: 'var(--vdr-line)'
  }
};

// Solo para mostrar en el eje: parte las etiquetas largas en líneas de ~12 caracteres para que
// no se oculten por solaparse ("Empresa de Distribución Eléctrica" -> 3 líneas).
const TICK_LINE_CHARS = 12;
const wrapTickLabel = (label: string): string =>
  String(label)
    .split(' ')
    .reduce<string[]>((lines, word) => {
      const last = lines[lines.length - 1];
      if (last !== undefined && `${last} ${word}`.length <= TICK_LINE_CHARS) {
        lines[lines.length - 1] = `${last} ${word}`;
      } else {
        lines.push(word);
      }
      return lines;
    }, [])
    .join('\n');

const BarChart: FunctionComponent<{ dataset: Array<{ value: number; name: string }> }> = ({
  dataset
}) => {
  const maxTickLines = Math.max(1, ...dataset.map((d) => wrapTickLabel(d.name).split('\n').length));
  return (
    <MuiBarChart
      dataset={dataset}
      colors={['#00708d']}
      grid={{ horizontal: true }}
      xAxis={[
        {
          scaleType: 'band',
          dataKey: 'name',
          tickLabelStyle: { fontSize: 11 },
          // Todas las categorías con su etiqueta (ya van partidas en líneas cortas).
          tickLabelInterval: () => true,
          valueFormatter: (value, context) =>
            context.location === 'tick' ? wrapTickLabel(value) : String(value)
        }
      ]}
      yAxis={[{ tickLabelStyle: { fontSize: 11.5 } }]}
      series={[
        {
          dataKey: 'value'
        }
      ]}
      height={300}
      margin={{ top: 16, right: 12, bottom: 22 + maxTickLines * 14, left: 40 }}
      sx={CHART_SX}
    />
  );
};

export default BarChart;
